module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      长按识别二维码"), _c('br'), _vm._v("\n      领取开店学习资料\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/yaoqing/code.jpeg"),
      "width": "100%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("如有咨询问题，可点击【专家咨询】")])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_vm._v("长按识别 关注后领取")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fb3dd08","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/register-yaoqing/result.vue
// module id = 368
// module chunks = 0